/**
 * Escape the five HTML-significant characters for safe interpolation into a raw HTML string
 * (e.g. print/label windows built via `document.write`). Use this instead of hand-rolled
 * replace chains so escaping stays consistent across callers.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
